import moment from 'moment-timezone';

export const DEFAULT_SERVER_TIMEZONE = "UTC";

const allowedPrefixes = [
    "America", "Antarctica", "Asia", "Atlantic", "Australia", 
    "Brazil", "Canada", "Chile", "Europe", "Indian", "Pacific", "US"
    //The are all common worldwide used ones, I did this because moments.tz includes more stuff that is irrelevant (GMT, PST etc.)
];

export const Timezones = moment.tz.names().filter(zone => {
    // Check if the timezone starts with any of the allowed prefixes
    return allowedPrefixes.some(prefix => zone.startsWith(prefix));
});


export const Countries = [
    "Afghanistan (AF)", "Albania (AL)", "Algeria (DZ)", "Andorra (AD)", "Angola (AO)", 
    "Antigua and Barbuda (AG)", "Argentina (AR)", "Armenia (AM)", "Australia (AU)", "Austria (AT)", 
    "Azerbaijan (AZ)", "Bahamas (BS)", "Bahrain (BH)", "Bangladesh (BD)", "Barbados (BB)", 
    "Belarus (BY)", "Belgium (BE)", "Belize (BZ)", "Benin (BJ)", "Bhutan (BT)", 
    "Bolivia (Plurinational State of) (BO)", "Bosnia and Herzegovina (BA)", "Botswana (BW)", "Brazil (BR)", 
    "Brunei Darussalam (BN)", "Bulgaria (BG)", "Burkina Faso (BF)", "Burundi (BI)", "Cabo Verde (CV)", 
    "Cambodia (KH)", "Cameroon (CM)", "Canada (CA)", "Central African Republic (CF)", "Chad (TD)", 
    "Chile (CL)", "China (CN)", "Colombia (CO)", "Comoros (KM)", "Congo (CG)", 
    "Congo, Democratic Republic of the (CD)", "Costa Rica (CR)", "Croatia (HR)", "Cuba (CU)", "Cyprus (CY)", 
    "Czechia (CZ)", "Côte d'Ivoire (CI)", "Denmark (DK)", "Djibouti (DJ)", "Dominica (DM)", 
    "Dominican Republic (DO)", "Ecuador (EC)", "Egypt (EG)", "El Salvador (SV)", "Equatorial Guinea (GQ)", 
    "Eritrea (ER)", "Estonia (EE)", "Eswatini (SZ)", "Ethiopia (ET)", "Fiji (FJ)", 
    "Finland (FI)", "France (FR)", "Gabon (GA)", "Gambia (GM)", "Georgia (GE)", 
    "Germany (DE)", "Ghana (GH)", "Greece (GR)", "Grenada (GD)", "Guatemala (GT)", 
    "Guinea (GN)", "Guinea-Bissau (GW)", "Guyana (GY)", "Haiti (HT)", "Honduras (HN)", 
    "Hungary (HU)", "Iceland (IS)", "India (IN)", "Indonesia (ID)", "Iran (Islamic Republic of) (IR)", 
    "Iraq (IQ)", "Ireland (IE)", "Israel (IL)", "Italy (IT)", "Jamaica (JM)", 
    "Japan (JP)", "Jordan (JO)", "Kazakhstan (KZ)", "Kenya (KE)", "Kiribati (KI)", 
    "Korea (Democratic People's Republic of) (KP)", "Korea, Republic of (KR)", "Kuwait (KW)", "Kyrgyzstan (KG)", 
    "Lao People's Democratic Republic (LA)", "Latvia (LV)", "Lebanon (LB)", "Lesotho (LS)", "Liberia (LR)", 
    "Libya (LY)", "Liechtenstein (LI)", "Lithuania (LT)", "Luxembourg (LU)", "Madagascar (MG)", 
    "Malawi (MW)", "Malaysia (MY)", "Maldives (MV)", "Mali (ML)", "Malta (MT)", 
    "Marshall Islands (MH)", "Mauritania (MR)", "Mauritius (MU)", "Mexico (MX)", 
    "Micronesia (Federated States of) (FM)", "Moldova (Republic of) (MD)", "Monaco (MC)", "Mongolia (MN)", 
    "Montenegro (ME)", "Morocco (MA)", "Mozambique (MZ)", "Myanmar (MM)", "Namibia (NA)", 
    "Nauru (NR)", "Nepal (NP)", "Netherlands (NL)", "New Zealand (NZ)", "Nicaragua (NI)", 
    "Niger (NE)", "Nigeria (NG)", "North Macedonia (MK)", "Norway (NO)", "Oman (OM)", 
    "Pakistan (PK)", "Palau (PW)", "Panama (PA)", "Papua New Guinea (PG)", "Paraguay (PY)", 
    "Peru (PE)", "Philippines (PH)", "Poland (PL)", "Portugal (PT)", "Qatar (QA)", 
    "Romania (RO)", "Russian Federation (RU)", "Rwanda (RW)", "Saint Kitts and Nevis (KN)", 
    "Saint Lucia (LC)", "Saint Vincent and the Grenadines (VC)", "Samoa (WS)", "San Marino (SM)", 
    "Sao Tome and Principe (ST)", "Saudi Arabia (SA)", "Senegal (SN)", "Serbia (RS)", 
    "Seychelles (SC)", "Sierra Leone (SL)", "Singapore (SG)", "Slovakia (SK)", "Slovenia (SI)", 
    "Solomon Islands (SB)", "Somalia (SO)", "South Africa (ZA)", "South Sudan (SS)", "Spain (ES)", 
    "Sri Lanka (LK)", "Sudan (SD)", "Suriname (SR)", "Sweden (SE)", "Switzerland (CH)", 
    "Syrian Arab Republic (SY)", "Tajikistan (TJ)", "Tanzania, United Republic of (TZ)", "Thailand (TH)", 
    "Timor-Leste (TL)", "Togo (TG)", "Tonga (TO)", "Trinidad and Tobago (TT)", "Tunisia (TN)", 
    "Turkey (TR)", "Turkmenistan (TM)", "Tuvalu (TV)", "Uganda (UG)", "Ukraine (UA)", 
    "United Arab Emirates (AE)", "United Kingdom (GB)", "United States of America (US)", "Uruguay (UY)", 
    "Uzbekistan (UZ)", "Vanuatu (VU)", "Venezuela (Bolivarian Republic of) (VE)", "Viet Nam (VN)", 
    "Yemen (YE)", "Zambia (ZM)", "Zimbabwe (ZW)"
];
